<template>
    <div class="notifications-icon">
        <svg
            class="filled-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="var(--text-body-default-base)"
            stroke="var(--text-body-default-base)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
            <path
                d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
        </svg>
        <svg
            class="empty-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--text-body-default-base)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
            <path
                d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
        </svg>
        <pendo-icon
            v-if="anyUnread"
            height="9px"
            width="9px"
            stroke-width="3px"
            class="red-dot"
            type="circle" />
    </div>
</template>

<script>
import { PendoIcon } from '@pendo/components';

export default {
    name: 'NotificationsIcon',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoIcon,
    },
    props: {
        anyUnread: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="less">
.notifications-icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .empty-icon,
    .filled-icon {
        width: 21px;
        height: 21px;
    }
}

.red-dot {
    position: absolute;
    left: 12px;
    top: 0px;

    :deep(.pendo-icon__content) {
        height: inherit !important;
        width: inherit !important;
        fill: var(--static-nav-icon-notification-unread-base);
        stroke: var(--static-nav-icon-notification-unread-base);
    }
}
</style>
